module.exports = __webpack_public_path__ + "static/media/XBOX3.4ad13712.png";